module.exports = __webpack_public_path__ + "img/avatar7.cea3befd.png";